import { Grid, withStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '../../../default'
import { CardFinancialConfig } from '../../../cards'

const PanelPlan = ({ classes }) => {

  const { t } = useTranslation()

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.financial.config.title')}</Label>
      </Grid>
      <Grid item xs={12}>
        <CardFinancialConfig />
      </Grid>
    </Grid>
  )
}


const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelPlan)